// client/src/api/usuarios.js
import api from "./config.js";

//Login de usuario
export const login = async (credentials) => {
  const { data } = await api.post("/usuarios/login", credentials);
  return data; // { token, usuario }
};

//Registrar usuario (Administrador o desde panel)
export const register = async (usuario) => {
  const { data } = await api.post("/usuarios", usuario);
  return data;
};

//Obtener todos los usuarios
export const getUsuarios = async () => {
  const { data } = await api.get("/usuarios");
  return data;
};

//Obtener usuario por ID
export const getUsuario = async (id) => {
  const { data } = await api.get(`/usuarios/${id}`);
  return data;
};

//Actualizar usuario
export const updateUsuario = async (id, usuario) => {
  const { data } = await api.put(`/usuarios/${id}`, usuario);
  return data;
};

//Eliminar usuario
export const deleteUsuario = async (id) => {
  const { data } = await api.delete(`/usuarios/${id}`);
  return data;
};

//Solicitar recuperación de contraseña
export const solicitarReset = async (correo) => {
  const { data } = await api.post("/usuarios/solicitar-reset", { correo });
  return data;
};

//Actualizar contraseña (clave temporal)
export const actualizarContrasenia = async (payload) => {
  const { data } = await api.post("/usuarios/actualizar-contrasenia", payload);
  return data;
};

//Verificar sesión actual con Cookie HttpOnly
export const verificarSesion = async () => {
  const { data } = await api.get("/usuarios/verificar-sesion");
  return data;
};

//Cerrar sesión en el servidor y limpiar Cookie HttpOnly
export const logout = async () => {
  const { data } = await api.post("/usuarios/logout");
  return data;
};

